/* eslint-disable no-undef */
import React, { useEffect } from "react";
import Chat from "./Chat";
import { Provider, inject, observer } from "mobx-react";
import HistoryView from "./History";
import { ensureError, reportError } from "./utilities";
import Store from "./store";
import { jwtDecode } from "jwt-decode";

const getNameFromToken = (token: string): string | null => {
  try {
    const decoded: any = jwtDecode(token);
    return decoded.name || null;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};

const getEmailFromToken = (token: string): string | null => {
  try {
    const decoded: any = jwtDecode(token);
    console.log("email: ", decoded.unique_name);
    return decoded.unique_name ?? decoded.preferred_username ?? null;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};

const App = inject("store")(
  observer(({ store }: { store: Store }) => {
    async function getToken() {
      try {
        const token = await OfficeRuntime.auth.getAccessToken({
          allowSignInPrompt: true,
          allowConsentPrompt: true,
          forMSGraphAccess: true,
        });
        store.setToken(token);

        store.setEmail(getEmailFromToken(token));
      } catch (error: unknown) {
        const causeError = ensureError(error);
        const reportingError = new Error(
          `ErrorInAuthenticationCause${causeError.message
            .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
            .replace(/\s/g, "")}`
        );
        reportError(reportingError, "");
      }
    }
    getToken();
    useEffect(() => {
      async function getToken() {
        try {
          const token = await OfficeRuntime.auth.getAccessToken({
            allowSignInPrompt: true,
            allowConsentPrompt: true,
            forMSGraphAccess: true,
          });
          store.setToken(token);

          store.setEmail(getEmailFromToken(token));
        } catch (error: unknown) {
          const causeError = ensureError(error);
          const reportingError = new Error(
            `ErrorInAuthenticationCause${causeError.message
              .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
              .replace(/\s/g, "")}`
          );
          reportError(reportingError, "");
        }
      }
      getToken();
    }, [store.view]);

    async function refreshAccessToken() {
      try {
        const token = await OfficeRuntime.auth.getAccessToken({
          allowSignInPrompt: true,
          allowConsentPrompt: true,
          forMSGraphAccess: true,
        });
        store.setToken(token);
        console.log("refreshed token: ", store.bearerToken);
      } catch (error) {
        console.error("Error refreshing access token:", error);
        // Handle errors (e.g., redirect to login)
      }
    }

    useEffect(() => {
      const tokenRefreshInterval = setInterval(() => {
        refreshAccessToken();
      }, 60 * 60 * 1000); // 15 minutes in milliseconds

      return () => {
        clearInterval(tokenRefreshInterval);
      };
    }, []);
    useEffect(() => {
      store.setHideIntro(false);
    }, []);

    const name = getNameFromToken(store.bearerToken);
    if (!store.getUsername()) store.setUsername(name);

    useEffect(() => {
      store.fetchProperties();
    }, [store.bearerToken]);

    useEffect(() => {
      async function fetchDocs() {
        if (!store.bearerToken) {
          await getToken();
        }
        console.log("store.bearerToken: ", store.bearerToken);
        await store.fetchFilteredDocuments();
      }
      fetchDocs();
    }, [store.filters, store.filtersApplied, store.bearerToken]);

    return (
      <Provider modelStore={store}>
        {store.view == "History" ? <HistoryView store={store} /> : <Chat store={store} />}
      </Provider>
    );
  })
);

export default App;
